import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment.prod';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseAPIClass } from '..';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionService extends BaseAPIClass {
  baseUrl = environment.serverBaseUrl;

  constructor(protected httpClient: HttpClient, handler: HttpBackend) {
    super(httpClient);
    this.httpClient = new HttpClient(handler);
    this.baseUrl = this.baseUrl + '/configuraciones';
  }

  updateLogo(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/logo`, payload).pipe(
      map((body: any) => {
        return body;
      })
    );
  }
}
